var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16C3.5816 16 0 12.4184 0 8C0 3.5816 3.5816 0 8 0ZM8 3.2C7.78783 3.2 7.58434 3.28429 7.43431 3.43431C7.28429 3.58434 7.2 3.78783 7.2 4V8C7.20005 8.21216 7.28436 8.41561 7.4344 8.5656L9.8344 10.9656C9.98528 11.1113 10.1874 11.192 10.3971 11.1901C10.6069 11.1883 10.8075 11.1042 10.9559 10.9559C11.1042 10.8075 11.1883 10.6069 11.1901 10.3971C11.192 10.1874 11.1113 9.98528 10.9656 9.8344L8.8 7.6688V4C8.8 3.78783 8.71571 3.58434 8.56569 3.43431C8.41566 3.28429 8.21217 3.2 8 3.2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFilled);
export default __webpack_public_path__ + "static/media/timeFilled.7e255bcec5647bf5e212860e7eb6a38c.svg";
export { ForwardRef as ReactComponent };